import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-character-counter',
  template: `
    <small class="text-muted d-block text-end">
      {{ currentLength }}/{{ maxLength }} {{ 'common.character' | translate }}
    </small>
  `
})
export class CharacterCounterComponent {
  @Input() control!: AbstractControl;
  @Input() maxLength: number = 500;

  get currentLength(): number {
    return this.control?.value?.length || 0;
  }
}
